import { Flex } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../../../ui-components';

export const IsSaleFinal: React.FC = () => (
    <Flex direction="row" justify="center">
        <Text color="slt-red-error" style="bold" trim>
            <FormattedMessage
                id="buy.box.final_sale.main"
                defaultMessage="Final Sale: Non-Returnable"
            />
        </Text>
    </Flex>
);
